import { ModalHeroImage } from '@strava/ui/Modal';
import React, { useEffect } from 'react';
import { analyticsPageName, t } from '../../../../shared/onboardingUtils';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import ActionButton, { ACTIONS } from '../../../ActionButton/ActionButton';
import subscriptionImage from './images/subscription.jpg';
import ModalBodyWithAlerts from '../../../ModalBodyWithAlerts';

import OnboardingModalActions from '../../../OnboardingModalActions';

import styles from './SubscriptionTrial.scss';
import { REGISTRATION_FLOW } from '../../../../shared/onboardingConstants';

const SubscriptionTrial = () => {
  const { state, track, dispatch } = useOnboardingContext();
  const { stepForward, isProcessing } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });

  const { alert } = state;

  useEffect(() => {
    track({
      page: analyticsPageName(REGISTRATION_FLOW.subscriptionTrial),
      action: 'screen_enter'
    });
  }, [track]);

  return (
    <>
      <ModalHeroImage
        src={subscriptionImage}
        alt={t('subscription_trial.heading')}
      />
      <ModalBodyWithAlerts alert={alert}>
        <h2>{t('subscription_trial.title')}</h2>
        <p>{t('subscription_trial.subtitle')}</p>
      </ModalBodyWithAlerts>

      <OnboardingModalActions>
        <ActionButton
          variant="default"
          onClick={() => stepForward({ action: ACTIONS.skip })}
          data-cy="skip-trial-next-step-btn"
          isProcessing={isProcessing}
          className={styles.actionBtn}
        >
          {t('subscription_trial.later')}
        </ActionButton>
        <ActionButton
          variant="primary"
          onClick={() => stepForward({ action: ACTIONS.startTrial })}
          data-cy="start-trial-next-step-btn"
          className={styles.actionBtn}
        >
          {t('subscription_trial.start')}
        </ActionButton>
      </OnboardingModalActions>
    </>
  );
};

export default SubscriptionTrial;
